import React from 'react';
import styled from 'styled-components';
import { colors } from '../utils/colors';

const Clavep = styled.p`
	margin-top: 0.4em;
	color: ${colors.white};
	font-weight: 300;
	max-width: 300px;
	padding: 0 2em 0 2em;
	margin: 0 auto;
	font-family: 'D-DinExp', sans-serif;
`;

const Clave = ({ contenido }) => (
	<div>
		<Clavep>{contenido}</Clavep>
	</div>
);

export default Clave;



// WEBPACK FOOTER //
// ./src/components/Clave.js